import { ReactNode, Fragment } from 'react';

import {
  Breadcrumb as UIBreadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import { Link } from '@/i18n/navigation';

type T_BreadcrumbItem = {
  label: string;
  href?: string;
};

type T_BreadcrumbProps = {
  items: T_BreadcrumbItem[];
  className?: string;
  separator?: ReactNode;
  'aria-label'?: string;
};

function Breadcrumb({
  items,
  className,
  separator,
  'aria-label': ariaLabel
}: T_BreadcrumbProps) {
  const lastIndex = items.length - 1;

  return (
    <UIBreadcrumb className={className} aria-label={ariaLabel}>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === lastIndex;

          return (
            <Fragment key={`${item.label}-${index}`}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="font-bold text-(--color-brand)">
                    {item.label}
                  </BreadcrumbPage>
                ) : item.href ? (
                  <BreadcrumbLink className="underline" asChild>
                    <Link href={item.href}>{item.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbLink className="underline" asChild>
                    <span>{item.label}</span>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && (
                <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>
              )}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </UIBreadcrumb>
  );
}

export default Breadcrumb;
